__turbopack_context__.v({
  "arrow": "hub-motion-module__IJq2bq__arrow",
  "drop": "hub-motion-module__IJq2bq__drop",
  "go": "hub-motion-module__IJq2bq__go",
  "hubDrop": "hub-motion-module__IJq2bq__hubDrop",
  "hubFade": "hub-motion-module__IJq2bq__hubFade",
  "hubRing": "hub-motion-module__IJq2bq__hubRing",
  "hubRow": "hub-motion-module__IJq2bq__hubRow",
  "hubSheet": "hub-motion-module__IJq2bq__hubSheet",
  "ring": "hub-motion-module__IJq2bq__ring",
  "row": "hub-motion-module__IJq2bq__row",
  "scrim": "hub-motion-module__IJq2bq__scrim",
  "sheet": "hub-motion-module__IJq2bq__sheet",
});
